<template>
  <div class="home">
    <v-container class="container">
      <v-banner
        v-if="false"
        class="blm-banner"
        @click.native="openLink(nationalResourceLink)"
      >
        <template v-slot:icon>
          <img
            src="@/assets/blm.jpg"
          >
        </template>
        <div>
          If you need help or can help others, please click the link for a list resources aimed at
          helping those in need and working to end systemic racism and abuse at the ends of police.
        </div>
        <a
          :href="nationalResourceLink"
          @click.prevent
        > National Resource List </a>
      </v-banner>
      <v-row>
        <v-col>
          <v-card
            class="about-me"
            max-width="600"
          >
            <v-card-title
              class="card-title"
            >
              <div>
                About Me
              </div>
            </v-card-title>
            <v-card-text>
              <img
                class="selfie"
                alt="Selfies help fuel a narcissistic personality."
                src="@/assets/me.jpg"
              >
              <div>
                Thanks for stopping by, my name is Tom Colarusso and I'm a software engineer who's
                been building scalable web applications since 2011. In my spare time, I enjoy
                video games, photography, running, and travel. Please take a look around and
                contact me via any of my social media profiles if you have any questions.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col v-if="showTwitterFeed">
          <v-card
            max-width="600"
          >
            <v-card-title
              class="card-title"
            >
              <twitter-icon />
              <div>
                Latest Tweets
              </div>
            </v-card-title>
            <v-card-text>
              <Timeline
                id="etcolarusso"
                source-type="profile"
                :options="{ tweetLimit: '10', theme: twitterTheme }"
              >
                <v-skeleton-loader
                  class="mx-auto"
                  max-width="300"
                  type="card"
                />
              </Timeline>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- <v-col>
          <v-card max-width="600">
            <v-card-title
              class="card-title"
            >
              <instagram-icon />
              <div>
                Latest Instagram
              </div>
            </v-card-title>
            <v-card
              class="mx-auto instagram-posts"
            >
              <instagram-feed
                :token="instagramAccessToken"
                :count="5"
                media-type="image"
              >
                <template
                  v-slot:loading="{ loading }"
                >
                  <v-skeleton-loader
                    v-if="loading"
                    class="mx-auto"
                    max-width="600"
                    type="card"
                  />
                </template>
                <template
                  v-slot:posts="{ post }"
                >
                  <v-card
                    class="instagram-post"
                    outlined
                  >
                    <a
                      :href="post.permalink"
                      target="_blank"
                    >
                      <v-img
                        contain
                        class="white--text align-end"
                        :src="post.media_url"
                      />
                      <v-card-text class="text--primary">
                        <div>{{ post.caption }}</div>
                      </v-card-text>
                    </a>
                  </v-card>
                </template>
                <template
                  v-slot:error="{ error }"
                >
                  <div v-if="error">
                    There was a problem refreshing the feed.
                    Please ensure you don't have any adblockers enabled.
                    Error: {{ error }}
                  </div>
                </template>
              </instagram-feed>
            </v-card>
          </v-card>
        </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { Timeline } from 'vue-tweet-embed';
// import InstagramFeed from '@/components/InstagramFeed.vue';
// import InstagramIcon from '@/components/InstagramIcon.vue';
import TwitterIcon from '@/components/TwitterIcon.vue';

export default {
  name: 'Home',
  components: {
    Timeline,
    // InstagramFeed,
    // InstagramIcon,
    TwitterIcon,
  },
  data: () => ({
    nationalResourceLink: 'https://linktr.ee/NationalResourcesList',
    acvGivingLink: 'https://go.rallyup.com/acvgiveeee/b3ed9b',
    showTwitterFeed: false,
    instagramAccessToken: 'IGQVJVOVpUSWVuejZATakRRTmRrT1hCTG9kelAtWVJSM3NaWGdFUjRPTWEzSVpMTk1QRkttcnVVT1ZADZAXhtcE9ZAX2lqS2lKMXJyYUNrQTFhai1tay1nWUpmSks2R1NCS3NtQ0ZAzMkJsZAGxCalR1NDRyZAQZDZD',
  }),
  computed: {
    twitterTheme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$vuetify.theme.dark': function () {
      this.showTwitterFeed = !this.showTwitterFeed;
      setTimeout(() => {
        this.showTwitterFeed = !this.showTwitterFeed;
      }, 0);
    },
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 600px;
}
.blm-banner {
  cursor: pointer;
}
.card-title {
  >:nth-child(n+2) {
    padding-left: 5px;
  }
}
a {
  text-decoration: none;
}
.instagram-posts{
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  .instagram-post {
    margin-bottom: 10px;
    ::v-deep .v-image__image {
      border-radius: 5px;
    }
  }
}
.about-me{
  img {
    width: 100%;
  }
}

</style>
